import React, {
  CSSProperties,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Button,
  Card,
  Dimmer,
  Divider,
  Grid,
  Image,
  Loader,
} from "semantic-ui-react";
import { Calendar } from "@natscale/react-calendar";
import "./calendarTekephar.scss";
import { CircularProgress, Skeleton } from "@mui/material";
import { Button as MuiButton } from "@mui/material";

import "@natscale/react-calendar/dist/main.css";
import moment, { Moment } from "moment";
import { FormattedMessage, useIntl } from "react-intl";
import SnackMessage from "react-lib/apps/common/SnackMessage";

// Controller
import QueueController from "../react-lib/apps/QUE/QueueController";

// Manager
import QUEManager from "../react-lib/apis/manager/QUEManager";
import PRXManager from "../react-lib/apis/manager/PRXManager";
import makeStyles from "@mui/styles/makeStyles";
// appointment
import AppCalendar, {
  BE_FORMAT_DATE,
  AppCalendarRef,
} from "bplus-lib/appointment/AppCalendar";
import DivisionServiceBlockDetail from "issara-sdk/apis/DivisionServiceBlockDetail_apps_QUE";

import { Event, State } from "bplus-lib/MobSmartAppointmentInterface";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

const IMAGES = {
  dismiss: "/images/register/dismiss.png",
};

type PostponeTelepharProps = {
  calendarList: any;
  selectedDate: any;
  loadingSkeleton: boolean;
  apiToken: any;
  gotoChatChannel: any;
  dataStateLocation: any;
  onSetChannelName: any;
  // Controller
  queueController: QueueController & {
    queManager: QUEManager;
    prxManager: PRXManager;
  };
  language?: any;
};
type TabMenuType = "morning" | "evening";
const ICON = {
  pin: "/images/telephar/pin_location_white.png",
  calendarWhite: "/images/telephar/icon_calendar_white.png",
  calendarBlue: "/images/telephar/icon_calendar_blue.png",
  information: "/images/telephar/icon_information.png",
};

const COLOR = {
  primary: "var(--primary-theme-color)",
  blue: "#0147A3",
  white: "white",
  lighterBlue: "#EBF1F8",
  lightBlue: "#A3D2F8",
  normalGrey: "#393939",
  lighter: "#DBE5F3",
  grey: "rgba(57, 57, 57, 1)",
  shadow: ".0625rem .5rem 1.125rem 0rem rgba(0, 102, 255, 0.1)",
  half_shadow: "0rem .25rem .5rem 0rem rgba(44, 44, 44, 0.08)",
  light_grey: "rgba(121, 120, 120, 1)",
};

const arrayMonth = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const beFormatDate = "YYYY-MM-DD";

const calendarStyles = {
  "& .calendar-custom": {
    boxShadow: COLOR.shadow,
    borderRadius: "1rem !important",
    "& .rc_header_nav": {
      boxShadow: `${COLOR.half_shadow} !important`,
    },
    "& .rc_header span": {
      color: `${COLOR.grey} !important`,
    },
    "& .rc_body-cell.rc_selected.rc_active .rc_body-cell_value": {
      background: `${COLOR.primary} !important`,
      borderRadius: `.5rem !important`,
      "&:before": {
        display: "none",
      },
      "& button": {
        color: `white !important`,
      },
    },
  },
};

const useStyles = makeStyles((theme) => ({
  screen: {},
  calendar: calendarStyles,
}));

const styles = {
  buttonConfirmBox: {
    margin: "30px 0",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  } as CSSProperties,
  buttonConfirm: {
    display: "flex",
    justifyContent: "center",
    background: COLOR.primary,
    color: "white",
    width: "70%",
    padding: "14px 0",
    fontWeight: "bold",
    fontSize: "18px",
    borderRadius: "8px",
  } as CSSProperties,
  boxWarning: {
    margin: "10px",
    background: COLOR.lighterBlue,
    border: `1px solid ${COLOR.lightBlue}`,
    borderRadius: "5px",
  } as CSSProperties,
  cardAppointment: {
    margin: "10px",
    padding: "10px",
    background: COLOR.primary,
    borderRadius: "5px",
  } as CSSProperties,
  setCenter: {
    display: "flex",
    justifyContent: "center",
  } as CSSProperties,
  buttonSection: {
    display: "flex",
    padding: "5px",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "20px",
  } as CSSProperties,
};

const PostponeTelephar = (props: PostponeTelepharProps) => {
  const intl = useIntl();
  const [selectedSlot, setSelectedSlot] = useState<any>("morning");
  const [timeList, setTimeList] = useState<any[]>([]);
  const [active, setActive] = useState<any[]>([]);
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const [selectedDate, setSelectedDate] = useState<Moment | null>(null);
  const [timeSlots, setTimeSlots] = useState<any[]>([]);
  const [loadSlots, setLoadSlots] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<any>(null);
  const [dateSelected, setDateSelected] = useState<any>(null);
  const [selectedDSB, setSelectedDSB] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [isDuplicate, setIsDuplicate] = useState<boolean>(false);
  const [disableTimeSlot, setDisableTimeSlot] = useState<string[]>([]);
  const initialViewDate = useRef<any>(null);
  const yearMonthList = useRef<string[]>([]);
  const classes = useStyles();
  const calendarRef = useRef<AppCalendarRef>();

  useEffect(() => {
    props.onSetChannelName({ name: props?.dataStateLocation?.chatName || "" });
    // gatData();
    const handleResize = () => {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const templateColumns = useMemo(() => {
    let size = Math.floor((dimensions.width - 30) / 100);
    size = size >= 10 ? size - 1 : size;
    const percent = 100 / size;
    return new Array(size).fill(`${percent}%`).join(" ");
  }, [dimensions]);

  const handleSortTime = (listSlot: any) => {
    return (listSlot || [])
      .sort((a: any, b: any) => {
        const tA = a.time.split(":").map(Number);
        const tB = b.time.split(":").map(Number);
        return tA[0] !== tB[0] ? tA[0] - tB[0] : tA[1] - tB[1];
      })
      .filter(
        (items: any, index: number, self: any) =>
          self.findIndex((item: any) => item.dsbID === items.dsbID) === index,
      );
  };

  const handleCheckDivisionServiceBlockAvailable = async (timeActive: any) => {
    const timeActiveDsb = timeActive.map((item: any) => item.dsbID);

    const [resProvider, errorProvider] =
      await props.queueController.loadDivisionServiceBlockAvailable({
        apiToken: props.apiToken,
        dsb: timeActiveDsb,
      });

    const timeAllList: any[] = [];
    if (!resProvider) {
      return [];
    } else {
      (resProvider || []).forEach((items: any) => {
        // console.log("Debug items.start_datetime_iso ",items.start_datetime_iso)
        const date = moment(items.start_datetime_iso).format(beFormatDate);
        const dateNum = moment(items.end_datetime_iso).format("YYYYMMDD");
        if (dateNum >= moment().format("YYYYMMDD")) {
          const timeSlotList = generateTimeSlots(items, dateNum);
          timeAllList.push(...timeSlotList);
        }
      });
      return timeAllList ?? [];
    }
  };

  const generateTimeSlots = (DSBItem: any, date: string) => {
    const start = moment.parseZone(DSBItem.start_datetime_iso);
    const end = moment.parseZone(DSBItem.end_datetime_iso);

    if (!start.isValid() || !end.isValid()) {
      console.warn("Invalid start/end datetime", {
        start: DSBItem.start_datetime_iso,
        end: DSBItem.end_datetime_iso,
      });
      return [];
    }
    if (!end.isAfter(start)) {
      console.warn("end must be after start");
      return [];
    }

    const slotMin = Number(DSBItem.slot_length);
    if (!Number.isFinite(slotMin) || slotMin <= 0) {
      console.warn("slot must be a positive number (minutes)", {
        slot: DSBItem.slot_length,
      });
      return [];
    }

    const totalMins = end.diff(start, "minutes");
    const steps = Math.floor(totalMins / slotMin);

    const result = [];
    for (let i = 0; i < steps; i++) {
      const s = start.clone().add(i * slotMin, "minutes");
      const startStr = s.format("HH:mm");
      result.push({
        time: startStr,
        dsbID: `${DSBItem.id}-${date}-${startStr}`,
        keyCheck: date,
      });
    }

    return result;
  };

  const timeActiveList = useMemo(() => {
    console.log("Debug timeSlots ", timeSlots);
    if (timeSlots) {
      const timeActive = (timeSlots || timeList || []).filter((item: any) => {
        return item.keyCheck === dateSelected.format("YYYYMMDD");
      });

      // console.log("Debug timeActive ", timeActive);
      const dayTime = timeActive.filter(
        (item: any) => moment(item.time, "HH:mm").format("HH") < "13",
      );
      const nightTime = timeActive.filter(
        (item: any) => moment(item.time, "HH:mm").format("HH") >= "13",
      );
      console.log("Debug ~ nightTime:", nightTime);
      console.log("Debug ~ dayTime:", dayTime);
      var listDisable = disableTimeSlot;
      if (dayTime.length > 0) {
        listDisable = listDisable.filter((item: any) => item != "morning");
      } else {
        if (!listDisable.includes("morning")) {
          listDisable.push("morning");
        }
      }

      if (nightTime.length > 0) {
        listDisable = listDisable.filter((item: any) => item != "evening");
      } else {
        if (!listDisable.includes("evening")) {
          listDisable.push("evening");
        }
      }
      console.log("Debug ~ listDisable:", listDisable);
      setDisableTimeSlot(listDisable);

      // console.log("Debug dayTime ", dayTime);
      // console.log("Debug nightTime ", nightTime);
      if (dayTime.length > 0) {
        setSelectedSlot("morning");
      } else {
        setSelectedSlot("evening");
      }

      const daySortTime = handleSortTime(dayTime);
      const nightSortTime = handleSortTime(nightTime);

      return { day: daySortTime, night: nightSortTime };
    } else {
      return {};
    }
  }, [timeSlots]);

  const handleSelectTime = (DSB: any) => {
    setSelectedDSB(DSB);
  };

  const handleUpdateAppointment = async () => {
    if (selectedDSB !== "") {
      setIsConfirmLoading(true);
      const selectedDSBSplit = selectedDSB.split("-");
      const [r, e, n] = await DivisionServiceBlockDetail.retrieve({
        apiToken: props.apiToken,
        pk: selectedDSBSplit?.[0] || "",
      });

      const appointmentList = (r.service_appointments || [])
        .filter((item: any) => item.estimated_at_iso)
        .map((item: any) => {
          const blockId = item.division_service_block;
          const estimated = moment(item.estimated_at_iso);

          return `${blockId}-${estimated.format("YYYYMMDD")}-${estimated.format(
            "HH:mm",
          )}`;
        });

      if (appointmentList.includes(selectedDSB)) {
        setIsConfirmLoading(false);
        setIsDuplicate(true);
        return;
      }

      const estimatedAt = `${selectedDSBSplit?.[1]}-${selectedDSBSplit?.[2]}`;
      const estimatedAtIso = moment(estimatedAt, "YYYYMMDD-hh:mm")
        .utcOffset("+07:00")
        .format("YYYY-MM-DDTHH:mm:ss.SSS000Z")
        .replace("Z", "+07:00");

      const [resProvider, errorProvider] =
        await props.queueController.updatePatientAppointmentTelephar({
          apiToken: props.apiToken,
          pk: props.dataStateLocation?.appointmentId,
          divisionServiceBlock: selectedDSBSplit?.[0] || "",
          status: "3",
          estimatedAt: estimatedAtIso,
        });
      if (errorProvider) {
        setIsConfirmLoading(false);
        setErrorMessage(errorProvider);
      } else {
        setIsConfirmLoading(false);
        props.gotoChatChannel(props.dataStateLocation.channelId);
      }
    }
  };

  const getCalendars = async (isTelemed: boolean) => {
    calendarRef.current?.getCalendar({
      isTelemed,
      appointmentType: "check_up",
    });
  };

  const handleOnLoad = () => {
    getCalendars(false);
  };

  const handleGetCalendar = async (dateRange: any[]) => {
    handleGetDataFormApi(dateRange);
  };

  const handleGetDataFormApi = async (dateRange: any[]) => {
    console.log("Debug ~ handleGetCalendar dateRange:", dateRange);
    setIsLoading(true);
    let promiseArr: any[] = [];
    dateRange.forEach((item: any) => {
      const startDateTime = moment(item.start_date).format(
        "YYYY-MM-DDTHH:mm:ssZ",
      );
      console.log("Debug ~ startDateTime:", startDateTime);
      const endDateTime = moment(item.end_date + ` 23:59:59`).format(
        "YYYY-MM-DDTHH:mm:ssZ",
      );
      console.log("Debug ~ endDateTime:", endDateTime);
      promiseArr.push(
        props.queueController.loadDivisionServiceBlockSummaryView({
          apiToken: props.apiToken,
          divisions: props.dataStateLocation?.division,
          provider: props.dataStateLocation?.provider,
          start_datetime: startDateTime, //item.start_date,
          end_datetime: endDateTime, //item.end_date,
        }),
      );
    });

    const response = await Promise.all(promiseArr);

    const mixItem = response.map((item: any) => {
      if (item[0].items) {
        return item[0].items;
      }
      return undefined;
    });
    console.log("Debug ~ mixItem:", mixItem);
    if (mixItem.length < 1) {
      setErrorMessage(
        response[0]?.[1] || "loadDivisionServiceBlockSummaryView error",
      );
      setActive([]);
      setTimeList([]);
    } else {
      const mixItem = response.map((item: any) => {
        if (item[0].items) {
          return item[0].items;
        }
        return undefined;
      });
      const DSBClone = mixItem.flat() || [];
      console.log("Debug ~ DSBClone:", DSBClone);
      const dateAllList: any[] = [];
      const timeAllList: any[] = [];
      DSBClone.forEach((items: any) => {
        // console.log("Debug items.start_datetime_iso ",items.start_datetime_iso)
        const date = moment(items.start_datetime_iso).format(beFormatDate);
        const dateNum = moment(items.end_datetime_iso).format("YYYYMMDD");
        const time = `${moment(items.start_datetime_iso).format("HH:mm")}`;
        if (dateNum >= moment().format("YYYYMMDD")) {
          if (
            !dateAllList.some(
              (item: any) => moment(item).format(beFormatDate) === date,
            )
          ) {
            const _availableDate = new Date(date);
            _availableDate.setHours(0, 0, 0, 0);
            dateAllList.push(_availableDate);
          }
          timeAllList.push({
            time: time,
            dsbID: items.id,
            keyCheck: dateNum,
          });
        }
      });
      let start_date = moment();
      const firstMonth = dateAllList?.[0] || start_date;
      initialViewDate.current = new Date(
        moment(firstMonth).format(beFormatDate),
      );
      yearMonthList.current = [moment(firstMonth).format("YYYY-MM")];
      setActive([...active, ...dateAllList]);
      setTimeList([...timeList, ...timeAllList]);
    }
    setIsLoading(false);
  };

  const handleDateChange = async (date: Moment | null) => {
    setDateSelected(moment(date));
    setSelectedDSB("");
    setLoadSlots(true);

    const timeActive = (timeList || []).filter((item: any) => {
      return item.keyCheck === moment(date).format("YYYYMMDD");
    });
    const timeActiveChecked = await handleCheckDivisionServiceBlockAvailable(
      timeActive,
    );
    console.log("Debug ~ timeActiveChecked:", timeActiveChecked);
    setLoadSlots(false);
    setTimeSlots(timeActiveChecked);
  };

  const handleGetNextMonth = async (dateRange: any[]) => {
    handleGetDataFormApi(dateRange);
  };

  const handleChangeTab = (newTab: TabMenuType) => {
    if (!disableTimeSlot.includes(newTab)) {
      setSelectedSlot(newTab);
    }
  };

  return (
    <div
      style={{
        margin: "10px",
        position: "relative",
      }}
      className="main-postpone"
    >
      <SnackMessage
        onEvent={{}}
        onClose={() => {
          setErrorMessage(null);
        }}
        error={errorMessage != null ? errorMessage : null}
        success={null}
      />
      {/* <div style={styles.boxWarning}>
        <Grid style={{ margin: "0px" }}>
          <Grid.Row style={{ padding: "1rem" }}>
            <Grid.Column
              width={2}
              style={{
                ...styles.setCenter,
                alignItems: "center",
                padding: "0px",
              }}
            >
              <Image
                src={ICON.information}
                style={{ width: "24px", height: "24px" }}
              />
            </Grid.Column>
            <Grid.Column width={14} style={{ padding: "0px" }}>
              <div
                style={{
                  fontSize: "14px",
                  color: "#008BF5",
                  whiteSpace: "pre-line",
                  marginLeft: "5px",
                }}
              >{`กรุณานัดหมายภายใน 24 ชม.\nเพื่อประสิทธิภาพที่ดีในการรักษาของท่าน`}</div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div> */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          margin: "10px 0",
        }}
      >
        <div
          style={{
            fontSize: "16px",
            fontWeight: "bold",
            color: COLOR.normalGrey,
            margin: "10px 0",
          }}
        >
          <FormattedMessage id="bplusClinicKey1270" />
        </div>
        <div></div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          position: "relative",
          flexDirection: "column",
        }}
      >
        <Dimmer active={isLoading} inverted style={{ zIndex: "9" }}>
          <Loader inverted>
            <FormattedMessage id="bplusClinicKey297" />
          </Loader>
        </Dimmer>
        <AppCalendar
          ref={calendarRef}
          className={classes.calendar}
          language={props.language}
          // data
          value={dateSelected}
          calendarList={{ active: active, inactive: [] }}
          // timeslotList={props.timeslotList}
          isLoadingCalendar={isLoading}
          isLoadingNextMonth={isLoading}
          // callback
          onChange={handleDateChange}
          onNextMonth={handleGetNextMonth}
          onGetCalendar={handleGetCalendar}
          onLoad={handleOnLoad}
        />
        {/* {useMemo(
          () => (
            <Calendar
              className="calendar-custom"
              value={dateSelected}
              onChange={onDateChange}
              disablePast={true}
              // disableToday={true}
              // disableFuture={true}
              isDisabled={handleIsDisabled}
              startOfWeek={0}
              size={dimensions.width}
              initialViewDate={initialViewDate.current || active?.[0]}
            />
          ),
          [dateSelected, dimensions, active]
        )} */}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          margin: "10px 0",
        }}
      >
        <div
          style={{
            fontSize: "16px",
            fontWeight: "bold",
            color: COLOR.normalGrey,
            margin: "10px 0",
          }}
        >
          <FormattedMessage id="bplusClinicKey1271" />
        </div>
        <div></div>
      </div>
      <div
        style={{
          display: "grid",
          padding: "10px",
          gridTemplateColumns: "1fr 1fr",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "30px",
          background: COLOR.lighter,
        }}
      >
        <div
          style={{
            ...styles.buttonSection,
            background: selectedSlot === "morning" ? COLOR.primary : "",
            color: selectedSlot === "morning" ? COLOR.white : COLOR.primary,
            fontWeight: selectedSlot === "morning" ? "bold" : "",
            opacity: disableTimeSlot.includes("morning") ? "0.5" : "1",
          }}
          onClick={() => {
            handleChangeTab("morning");
          }}
        >
          <FormattedMessage id="bplusClinicKey1272" />
        </div>
        <div
          style={{
            ...styles.buttonSection,
            background: selectedSlot === "evening" ? COLOR.primary : "",
            color: selectedSlot === "evening" ? COLOR.white : COLOR.primary,
            fontWeight: selectedSlot === "evening" ? "bold" : "",
            opacity: disableTimeSlot.includes("evening") ? "0.5" : "1",
          }}
          onClick={() => {
            handleChangeTab("evening");
          }}
        >
          <FormattedMessage id="bplusClinicKey1273" />
        </div>
      </div>

      <div
        style={{
          padding: "13px 10px 10px 10px",
          minHeight: "20vh",
        }}
      >
        <div>
          {(timeActiveList.day != null && timeActiveList.night != null) ||
          loadSlots ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: `${templateColumns}`,
                rowGap: "12px",
              }}
            >
              {(loadSlots
                ? new Array(4).fill("")
                : selectedSlot === "morning"
                ? timeActiveList?.day || []
                : timeActiveList?.night || []
              )?.map((item: any, index: number) => (
                <div
                  key={"slot-" + index}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Button
                    className="button-slot"
                    style={{
                      fontSize: "14px",
                      padding: "12px 30px",
                      boxShadow: `0px 4px 8px rgba(44, 44, 44, 0.08)`,
                      borderRadius: "16px",
                      color:
                        selectedDSB === item.dsbID && !loadSlots
                          ? "white"
                          : COLOR.normalGrey,
                      background:
                        selectedDSB === item.dsbID && !loadSlots
                          ? COLOR.primary
                          : "white",
                      // selectedSlot?.start_time
                      //   ? { background: COLOR.blue, color: "white" }
                      //   : props.loadingSkeleton
                      //   ? { background: COLOR.opacity, border: 0 }
                      //   : {}),
                    }}
                    onClick={() => handleSelectTime(item.dsbID || "-")}
                    disabled={props.loadingSkeleton}
                  >
                    {loadSlots ? (
                      <Skeleton
                        animation="pulse"
                        variant="rounded"
                        width={40}
                        height={14}
                      />
                    ) : (
                      item.time
                    )}
                  </Button>
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{
                margin: "20px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ background: "#f6f7f7", padding: "13px" }}>
                {intl.formatMessage({ id: "bplusClinicKey336" })}
              </div>
            </div>
          )}
        </div>
      </div>

      <div style={styles.buttonConfirmBox}>
        <Button
          style={styles.buttonConfirm}
          disabled={!selectedDSB || isConfirmLoading}
          onClick={() => handleUpdateAppointment()}
        >
          <FormattedMessage id="bplusClinicKey1278" />
          {isConfirmLoading && (
            <CircularProgress
              style={{
                marginLeft: "0.2rem",
              }}
              size={16}
            />
          )}
        </Button>
      </div>

      <Dialog open={isDuplicate} className="smart-dialog-container">
        <DialogContent>
          <div className="content">
            <img
              src={IMAGES.dismiss}
              alt="online appointment"
              style={{ width: "60px",marginBottom: "1.5rem"  }}
            />
            <div
              className="title"
              style={{ textAlign: "center", marginBottom: "1.5rem" }}
            >
              <FormattedMessage id="bplusClinicKey1034" />
            </div>
          </div>

          <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
            <FormattedMessage id="bplusClinicKey1500" />
          </div>

          <div className="button-submit-bottom">
            <MuiButton
              variant="contained"
              color="primary"
              style={{ width: "87.5%" }}
              onClick={() => {
                setIsDuplicate(false);
                setSelectedDSB(undefined);
              }}
            >
              <FormattedMessage id="bplusClinicKey1078" />
            </MuiButton>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default React.memo(PostponeTelephar);
